import { LinkButton, UIHeading1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface IReviewsEmptySnippetProps {
  elementId?: string;
  title: string;
  description: string;
  writeReviewButtonUrl?: string | null;
  onWriteButtonClick?: VoidFunction;
}

export function ReviewsEmptySnippet({
  elementId,
  title,
  description,
  writeReviewButtonUrl,
  onWriteButtonClick,
}: IReviewsEmptySnippetProps) {
  return (
    <div className={styles['container']} id={elementId} data-testid="reviews-empty-snippet">
      <div className={styles['title']}>
        <UIHeading1>{title}</UIHeading1>
      </div>
      <div className={styles['subtitle']}>
        <UIText2>{description}</UIText2>
      </div>
      {writeReviewButtonUrl && (
        <LinkButton
          theme="fill_primary"
          size="M"
          href={writeReviewButtonUrl}
          target="_blank"
          onClick={onWriteButtonClick}
        >
          Написать отзыв
        </LinkButton>
      )}
    </div>
  );
}
